<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <section class="modal-body">
          <header class="modal-header">
            <span class="entity-title" v-if="action=='create'">{{ $t('tournament.addMatch') }} </span>
            <span class="entity-title" v-if="action=='edit'">{{ $t('tournament.editMatch') }}  </span>
          </header>
          <div class="content"> 
            <div class="details">
            <div class="inputFields">
              <div>
                {{ $t('match.whitePlayer') }}
              </div>
              <select class="theme-input" v-model="match.whitePlayerId">
                <option class="placeholder" value="-1" disabled selected hidden>{{ $t('match.selectPlayer') }}</option>
                <option v-for="participant in sortedParticipants" :value="participant.participantId" v-bind:key="participant.participantId">{{participant.person.name}}</option>
              </select>         

              <div>  
                {{ $t('match.blackPlayer') }}
              </div>
              <select class="theme-input" v-model="match.blackPlayerId">
                <option class="placeholder" value="-1" disabled selected hidden>{{ $t('match.selectPlayer') }}</option>
                <option v-for="participant in sortedParticipants" :value="participant.participantId" v-bind:key="participant.participantId">{{participant.person.name}}</option>
              </select>    

              <div>  
                {{ $t('match.result') }}
              </div>
              <select class="theme-input" v-model="match.result"> 
                <option :value="0"> - </option>
                <option :value="1">1-0</option>
                <option :value="2">0-1</option>
                <option :value="3">&frac12;-&frac12;</option>
              </select>
              <br/>  
              <div>
              <i :title="$t('match.fix')" :class="{'fa fa-check-square-o': isMatchFixed(), 'fa fa-square-o': !isMatchFixed()}" @click="fixMatch()"></i>  fix match
              </div>

              <div class="buttons">
                <button class="button-default" @click="addAndNew">{{ $t('app.actions.addAndNew') }}</button>
              </div>
              <div class="buttons">
                <div v-if="action=='edit'">
                  <button class="button-default" @click="edit">{{ $t('app.actions.edit') }}</button>
                </div>
                <div v-if="action=='create'">
                  <button class="button-default" @click="add">{{ $t('app.actions.add') }}</button>
                </div>
                <button class="button-default" @click="cancel">{{ $t('app.actions.cancel') }}</button>
              </div>
            </div>
          </div>
          </div>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';

export default {
  name: 'addMatch',
  components: {},
  props: {
    action: String,
    groupId: String,
    matchId: String,
    roundId: String,
    tournamentId: String,    
    participants: { type: Array, required: false, default: () => [{ participantId: 0, name: "No players provided" }] },
    scores: { type: Array, required: false, default: () => [{ scoreId: 0, name: "No scores provided" }] }
  },
  data: function () {
    return {
      match: {tournamentId: this.$route.params.tournamentId},
      afterAddAndNew: false,
      sortedParticipants: []
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    if (this.action == "edit") {
      this.loadMatch();
    }
    this.sortedParticipants = this.sortParticipants();
    //console.log("participants in : " + JSON.stringify(this.participants));
  },
  methods: {
    add: function () {
      let that = this;
      this.match.roundId = this.roundId;
      this.match.groupId = this.groupId;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.match,
        response: false, 
      };
      console.log("trying to add: " + JSON.stringify(this.match));
      let path = '/match/';
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.match = response;
            that.$emit('ok');
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    addAndNew() {
      let that = this;
      this.match.roundId = this.roundId;
      this.match.groupId = this.groupId;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.match,
        response: false, 
      };
      let path = '/match/';
      RestAPI
        .post(apiName, path, myInit)
        .then(response => {
            that.match = response;
            console.log("match saved: "+ that.match.matchId);
            // Do not emit, but reset for a new match.
            that.afterAddAndNew = true;
            that.match = {tournamentId: that.$route.params.tournamentId, number: -1};
            console.log("match reset. ");
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    cancel: function() {
      if (this.afterAddAndNew)
        this.$emit('ok');
      else
        this.$emit('cancel');
    },

    edit: function () {
      let that = this;
      const myInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.match,
        response: false, 
      };
      let path = "/match/" + this.matchId;
      RestAPI
        .put(apiName, path, myInit)
        .then(response => {
            console.log("match edited: " + response);
            that.$emit('ok');
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    fixMatch() {
      console.log("fixing: " + this.match.fixed);
      if (this.match.fixed != null) {
        this.match.fixed = !this.match.fixed;
      } else {
        this.match.fixed = true;
      }
    },

    isMatchFixed: function() {
      var retValue = false;

      if (this.match.fixed != null) {
        if (this.match.fixed == true) {
          retValue = true;
        }
      }

      return retValue;
    },

    loadmatch: function () {
      let that = this;
      const myInit = { 
        response: false, 
      };
      let path = '/match/' + this.matchId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
            that.match = response;
            console.log("match loaded: "+ that.match.matchId);
        })
        .catch(error => {
          console.log(error.response);
        });
    },

    sortParticipants() {
      return Array.from(this.participants).sort((a, b) => {
        if (a.person.name < b.person.name) {
          return -1
        }
        if (a.person.name > b.person.name) {
          return 1
        }
        return 0
      })
    }
  }
}

</script>

<style scoped>

.fa {
    color: #333333;
  }

.fa:hover {
  color: #365c96; 
  transition: color .3s linear;
  cursor: pointer;
}

.fa-check-square-o {
  color: auto;
}


</style>
